import { render, staticRenderFns } from "./MaterialExci.vue?vue&type=template&id=d81a95de&scoped=true"
import script from "./MaterialExci.vue?vue&type=script&lang=js"
export * from "./MaterialExci.vue?vue&type=script&lang=js"
import style0 from "./MaterialExci.vue?vue&type=style&index=0&id=d81a95de&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d81a95de",
  null
  
)

export default component.exports